<template>
  <div class="home-page">
    <!-- <van-image  @click="goActivity" width="360" height="150" fit="fill"  :src="require('@/assets/images/travel/banner.jpg')" /> -->
    <van-search 
      v-model="searchName" 
      placeholder="请输入城市或景点名称" 
      @search="onSearch(searchName)"
    />
    <van-swipe 
      v-if="recommendTravels.length"
      @change="onChange"
      class="my-swipe" 
      :loop="false" 
      :width="232" 
      :height="154"
      :autoplay="3000" 
      :show-indicators="false"
      indicator-color="white">
      <van-swipe-item 
        v-for="(travel, index) in recommendTravels"
        :ref="`swipeItem${index}`"
        :key="travel.id"
        @click="goTravelDetail(travel.id)"
      >
        <recommend-travel 
          :imageUrl="processImgs(travel.imgs)" 
          :playDays="travel.playDays"
          :name="travel.name"
        />
      </van-swipe-item>
    </van-swipe>
    <van-row class="hot-travel" v-if="newTravels.length">
      <div class="hot-travel-circle"></div>
      <span class="hot-travel-text">最新游记</span>
    </van-row>
    <TravelCard 
      class="new-travel-card"
      v-for="(travel,index) in newTravels"
      :key="`${travel.id}`"
      :item="travel"
    ></TravelCard>
    <div class="more-travel" @click="goMoreNewTravel"  v-if="newTravels.length">
      <span>查看更多精彩游记</span>
      <van-icon name="arrow" />
    </div>
  </div>
</template>
<script>
//使用vant的懒加载
import {mapState,mapActions,mapMutations } from 'vuex';
import {  Image as VanImage,Search ,Swipe, SwipeItem , Icon, Button, Row  } from 'vant';
import  TravelCard from "@/mobileCom/TravelCard";
import RecommendTravel from '@/mobileCom/RecommendTravel';
export default {
  name: "main-page",
  components: {
    [Icon.name]: Icon,
    [Swipe.name]: Swipe,
    [SwipeItem.name ]: SwipeItem,
    TravelCard,
    [Search.name] :Search,
    [Button.name] : Button,
    VanImage,
    [Row.name]:Row,
    RecommendTravel
  },
  data() {
    return {
    
      searchName: ""
    };
  },
  computed: {
    ...mapState("HomeDataStore", ["newTravels","recommendTravels"])
  },
  watch: {
    searchName(value) {
      this.searchValueMutations(value);
    }
  },
  created() {
    //查询推荐游记
    let userId = this.$cookie.get("userInfo_userId"),
      dataType = 14,
      page = 1,
      rows = 5;
    if (userId) {
      this.recommendTravelNoteList({ userId, dataType, page, rows });
    } else {
      this.recommendTravelNoteList({ dataType,  page, rows });
    }
    //查询最新游记(5篇)
    this.getnewTravels({
      page: 1,
      rows: 10,
      dataType: 14,
      word: "",
      flag: 1
    });
  },
  methods: {
    onChange(index){
      this.$refs[`swipeItem${index}`][0].$el.style.width = "232px"
      if (index === this.recommendTravels.length - 1) {
        this.$refs[`swipeItem${index-1}`][0].$el.style.width = "190px"
      } 
    },
    onSearch(searchName) {
      if (searchName) {
        //跳转到搜索页面
        this.$router.push("searchList");
      } else {
        this.$toast("无可匹配关键词，请输入关键词后搜索!");
      }
    },
    goTravelDetail(travelId) {
      this.$router.push({ path: `/travelDetail/${travelId}` }) 
    },
     processImgs(imgs) {
      if (imgs) {
        return imgs.split(";")[0];
      }
      return imgs;
    },
    goActivity() {
      this.$router.push({name: "activity"});
    },
    goMoreNewTravel() {
      this.$router.push({name: "newTravelList"});
    },
    ...mapMutations("HomeDataStore", ["searchValueMutations"]),
    ...mapActions("HomeDataStore", [
      "recommendTravelNoteList",
      "getnewTravels"
    ]),
  }
};
</script>
<style lang="less">
@import "~@/mobile_css/list_related.less";
.home-page {
   padding-left:11px;
   padding-right:16px;
   padding-top: 13px;
  .hot-travel {
    .hot_travel_common();
  }
  .new-travel-card {
    margin-bottom: 12px;
  }
  .more-travel {
    color: #999999;
    font-size: 13px;
    display: flex;
    justify-content: center;
    //垂直方向居中对齐
    align-items: center;
    margin-bottom: 21px;
  }
  .my-swipe {
    .van-swipe-item:not(:last-child) {
      margin-right: 12px;
    }
  }
}
</style>
